import { render, staticRenderFns } from "./ProCartConfig.vue?vue&type=template&id=4688cf3e&"
import script from "./ProCartConfig.vue?vue&type=script&lang=js&"
export * from "./ProCartConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports